/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import type AppService from 'embercom/services/app-service';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { captureException } from '@sentry/browser';
import type IntlService from 'ember-intl/services/intl';
import { type TaskGenerator } from 'ember-concurrency';
import { dropTask } from 'ember-concurrency-decorators';
import { taskFor } from 'ember-concurrency-ts';

export default class RemoveTeammateController extends Controller {
  queryParams = [''];

  @service declare appService: AppService;
  @service declare notificationsService: $TSFixMe;
  @service declare intl: IntlService;
  @service declare router: Router;

  @tracked selectionIsValid = false;

  declare model: $TSFixMe;

  @action
  removeTeammate() {
    return taskFor(this.removeTeammateTask).perform();
  }

  @dropTask
  *removeTeammateTask(): TaskGenerator<void> {
    let { teammate, reassignments } = this.model;
    let permission = teammate.currentAppPermissions;

    try {
      yield permission.destroyRecord({ adapterOptions: { reassignments } });
      this.appService.app.admins.removeObject(teammate);
      permission.unloadRecord();
      teammate.unloadRecord();
      this.notificationsService.notifyConfirmation(
        this.intl.t('settings.teammates.remove-teammate.notification.successful-removal', {
          teammateName: teammate.displayAs,
          appName: this.model.app.name,
        }),
      );
      this.router.transitionTo('apps.app.settings.workspace.teammates');
    } catch (e: unknown) {
      let error = e as { jqXHR?: { status: number; responseJSON: { message: string } } };
      if (error.jqXHR?.status === 403) {
        this.notificationsService.notifyError(error.jqXHR.responseJSON.message);
      } else {
        this.notificationsService.notifyError(
          this.intl.t('settings.teammates.remove-teammate.notification.unexpected-failure'),
        );
        captureException(e);
      }
    }
  }
}
